function n(t) {
  return t instanceof HTMLElement;
}
function c(t) {
  for (let r = 0; r < t.childNodes.length; r++) {
    const e = t.childNodes[r];
    if (n(e) && (u(e) || c(e)))
      return !0;
  }
  return !1;
}
function i(t) {
  for (let r = t.childNodes.length - 1; r >= 0; r--) {
    const e = t.childNodes[r];
    if (n(e) && (u(e) || i(e)))
      return !0;
  }
  return !1;
}
function u(t) {
  if (!s(t))
    return !1;
  try {
    t.focus({ preventScroll: !0 });
  } catch (r) {
  }
  return document.activeElement === t;
}
function s(t) {
  if (t.tabIndex > 0 || t.tabIndex === 0 && t.getAttribute("tabIndex") !== null)
    return !0;
  if (t.getAttribute("disabled"))
    return !1;
  switch (t.nodeName) {
    case "A":
      return !!t.href && t.rel !== "ignore";
    case "INPUT":
      return t.type !== "hidden" && t.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}
export {
  c as focusFirstDescendant,
  i as focusLastDescendant
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/focus-trap/src/utils.js
// module id = 1784
// module chunks = 67